var React = require('react');

function ChevDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 6a.502.502 0 01-.354-.146l-4-4a.502.502 0 01.708-.708L5.5 4.793l3.646-3.647a.502.502 0 01.708.708l-4 4A.502.502 0 015.5 6","stroke":"currentColor","fill":"none","fillRule":"evenodd"}));
}

ChevDown.defaultProps = {"viewBox":"0 0 11 7"};

module.exports = ChevDown;

ChevDown.default = ChevDown;
